import * as orderTypes from '../types/orderTypes';

const initialState = {
  orders: [],
  order: null,
  pagination: null,
  loading: false,
  error: null,
  message: null,
  ordersHydrated: false,
};

const orderReducer = (state = initialState, action) => {
  switch (action.type) {
    case orderTypes.GET_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        message: null,
        order: null,
      };

    case orderTypes.CREATE_ORDER_REQUEST:
    case orderTypes.GET_ORDERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        message: null,
      };

    case orderTypes.CREATE_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        order: action.payload?.data ?? action.payload ?? null,
        message: 'Order created successfully',
        error: null,
      };

    case orderTypes.GET_ORDERS_SUCCESS:
      return {
        ...state,
        loading: false,
        ordersHydrated: true,
        orders:
          action.payload?.data ??
          action.payload?.orders ??
          (Array.isArray(action.payload) ? action.payload : []),
        pagination: action.payload?.pagination ?? null,
        error: null,
      };

    case orderTypes.GET_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        order: action.payload?.data ?? action.payload ?? null,
        error: null,
      };

    case orderTypes.GET_ORDERS_FAILURE:
      return {
        ...state,
        loading: false,
        ordersHydrated: true,
        orders: [],
        error: action.payload,
      };

    case orderTypes.CREATE_ORDER_FAILURE:
    case orderTypes.GET_ORDER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case orderTypes.CLEAR_ORDER_ERROR:
      return { ...state, error: null };

    case orderTypes.CLEAR_ORDER_MESSAGE:
      return { ...state, message: null };

    default:
      return state;
  }
};

export default orderReducer;
